// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__3p2bV","text":"Footer_text__n-n0w"};